/* Salon by Ordo — shared site script: i18n engine, nav, reveal animations, waitlist form, cookie banner */

(function(){
  "use strict";

  /* ---------------------------------------------------------------------
   * TRANSLATIONS
   * All keys used across index.html, privacy.html and terms.html live in
   * one dictionary so a single script can drive every page.
   * ------------------------------------------------------------------- */
  var translations = {
    en: {
      /* nav */
      "nav.system": "The System",
      "nav.workflow": "Workflow",
      "nav.who": "Who It's For",
      "nav.origin": "Our Story",
      "nav.cta": "Shop",
      "nav.shopall": "Shop All",

      /* shop all */
      "shopall.eyebrow": "Every part, on its own",
      "shopall.h2": "Shop all.",
      "shopall.p": "Boxes, protection, modules, inserts and add-ons, available individually. Grow your setup, replace a part, or build something new, piece by piece.",
      "shopall.base.h3": "ORDO Base",
      "shopall.base.p": "The empty shell every station starts from. Small, Medium or Large, same grid throughout.",
      "shopall.protect.h3": "Protection",
      "shopall.protect.p": "Inner base protection and anti-slip pads, keeping every base steady and every surface safe underneath.",
      "shopall.modules.h3": "Frame Modules",
      "shopall.modules.p": "The building cubes of every station, from a single slot to a full row.",
      "shopall.elevation.h3": "Elevation modules",
      "shopall.elevation.p": "Solid blocks that lift a module higher in your base, so shorter tools and products stay visible and within reach.",
      "shopall.inserts.h3": "Functional modules",
      "shopall.inserts.p": "Slot-fit organisers for shears, combs, clippers and trimmers, sized to your cubes.",
      "shopall.addons.h3": "Add-Ons",
      "shopall.addons.p": "Clips onto the outer wall for clipper guards, styling tools and holders, without costing you grid space inside.",
      "shopall.contact.eyebrow": "Looking for something specific",
      "shopall.contact.h2": "Can't find the part you need?",
      "shopall.contact.p": "Email us the SKU, size or a photo of your setup and we'll help you find the right piece.",
      "shopall.contact.cta": "Email info@ordobox.be",

      /* hero */
      "hero.eyebrow": "For hairstylists, barbers &amp; beauty professionals",
      "hero.h1": "Your tools.<br>Your flow.<br>Built to work beautifully.",
      "hero.sub": "A modular system, built around the way you work. Three sizes, endless configurations.",
      "hero.qualifier": "Three sizes. One modular system.",
      "hero.cta": "Shop the collection",
      "hero.waitlist_link": "Want a custom build or a new colour? Join the notify list",
      "hero.microcopy": "Join the first professionals shaping Salon by Ordo.",
      "shop.custom.eyebrow": "Build your own",
      "shop.custom.h3": "Custom configuration",
      "shop.custom.p": "Start from an empty base and add exactly the modules you need, piece by piece.",
      "shop.custom.cta": "Open the configurator",

      /* waitlist form (shared by hero + final CTA) */
      "form.email.placeholder": "Your work email",
      "form.submit": "Get Early Access",
      "form.consent": "I agree to the <a href=\"/pages/privacy-policy\">privacy policy</a> and consent to being contacted about Salon by Ordo.",
      "form.thanks.h3": "You're on the list.",
      "form.thanks.p1": "We'll be in touch as the first modules take shape — with founder pricing and a say in what we build.",
      "form.thanks.p2": "We'll be in touch as the first modules take shape.",

      /* shop */
      "shop.eyebrow": "Available now",
      "shop.h2": "Choose your station.",
      "shop.p": "Three sizes, one system. Start where your kit is today — every size configures the same way.",
      "shop.cta": "Shop now",

      /* system section */
      "system.eyebrow": "A station, not a storage box",
      "system.h2": "A modular professional station.<br>Not another plastic organiser.",
      "system.p": "One considered base. A growing set of modules. Configure a setup around the tools and products you actually reach for — then reshape it when your service changes. Precision-made, layer by layer, to sit as well in your hands as it does on your station.",

      /* before/after */
      "transform.eyebrow": "The difference on your station",
      "transform.h2": "From everything, everywhere<br>to everything in its place.",
      "transform.p": "Every professional knows the drawer, the trolley, the bag where tools tangle and time disappears. Salon by Ordo turns that chaos into a system built around your hands.",
      "ba.before.tag": "Before",
      "ba.before.caption": "Tangled tools. Lost minutes. A station working against you.",
      "ba.after.tag": "After",
      "ba.after.caption": "One modular system. Every essential visible, sorted and within reach.",

      /* three outcomes */
      "flow.eyebrow": "Configure · Work · Reset",
      "flow.h2": "Everything visible.<br>Within reach. In its place.",
      "flow.cell1.h3": "Configure your craft",
      "flow.cell1.p": "Build a setup around your own kit — shears, clippers, brushes, colour, product — then reconfigure it when you move from cutting to colour, nails or lash work.",
      "flow.cell2.h3": "Everything in flow",
      "flow.cell2.p": "A considered place for each essential keeps your station focused and calm, so the next move is always one clean motion away.",
      "flow.cell3.h3": "Made to move",
      "flow.cell3.p": "A personal, organised kit that travels with your day — chair to trolley, suite to set to home visit — and sets back up in seconds.",

      /* flow image split */
      "flowimg.eyebrow": "Built for the service",
      "flowimg.h2": "Designed for the pace<br>you actually work at.",
      "flowimg.p": "Beauty work is fast, tactile and unforgiving of clutter. Salon by Ordo is shaped around real service moments — the reach mid-blow-dry, the reset between clients, the setup at a new location — so your station keeps up with your craft instead of slowing it down.",

      /* who it's for */
      "who.eyebrow": "One system, many crafts",
      "who.h2": "Made for the professionals<br>behind the chair.",
      "persona.barber.h3": "The Barber",
      "persona.barber.p": "Blades, clippers and combs, ordered for the fade — a station that keeps pace with every client in the chair.",
      "persona.colourist.h3": "The Colourist",
      "persona.colourist.p": "Bowls, brushes, foils and formulas — each in its place, so precision colour work never waits on the search.",
      "persona.stylist.h3": "The Stylist",
      "persona.stylist.p": "Shears, sectioning clips and finishing tools, laid out for flow from first cut to final mirror.",
      "persona.nail.h3": "The Nail Artist",
      "persona.nail.p": "Polishes, files and fine brushes within a fingertip's reach, for detail work that stays calm and clean.",
      "persona.makeup.h3": "The Makeup Artist",
      "persona.makeup.p": "Brushes, palettes and product, organised for the look — every tool ready before the light hits.",

      /* origin */
      "origin.eyebrow": "The Ordo origin",
      "origin.h2": "Born from a system<br>built for professional kitchens.",
      "origin.p": "Ordo began on the pass — a modular toolbox made by chefs, for chefs, where mise-en-place and flow decide the night. Salon by Ordo carries that same discipline behind the chair: everything considered, everything in its place, so professionals can focus on the work they're known for.",

      /* faq */
      "faq.eyebrow": "Good to know",
      "faq.h2": "Questions, answered.",
      "faq.q1": "What exactly is Salon by Ordo?",
      "faq.a1": "A modular organisation system for hairstylists, barbers and beauty professionals. One base and a growing set of modules that you configure around the tools you actually reach for, then reshape when your service changes.",
      "faq.q2": "Which sizes are available and what do they cost?",
      "faq.a2": "Every ready-made set comes in Standard or With Add-ons. Small: &euro;89,99 / &euro;99,99. Medium: &euro;109,99 / &euro;129,99. Large (Hairdresser only): &euro;139,99 / &euro;159,99. All sizes are built on the same modular system, so modules work across sizes.",
      "faq.q3": "Can I build my own configuration?",
      "faq.a3": "Yes. Start from an empty base in the configurator and add exactly the modules you need, piece by piece. You can find it at configure.salonbyordo.com.",
      "faq.q4": "Who is it made for?",
      "faq.a4": "Working professionals behind the chair: hairstylists, barbers, colourists, make-up artists and nail professionals.",
      "faq.q5": "How does Salon by Ordo relate to Ordo?",
      "faq.a5": "Ordo began as a modular toolbox made by chefs, for chefs, where mise-en-place and flow decide the night. Salon by Ordo carries that same discipline behind the chair.",
      "faq.q6": "How do shipping and returns work?",
      "faq.a6": "Full details are set out in our Shipping Policy and our Return and Refund Policy, both linked in the footer of every page.",

      /* final cta */
      "final.eyebrow": "Stay in the loop",
      "final.h2": "New colours. New modules.",
      "final.sub": "Already shipping in three sizes. Join the notify list to hear first about new colours, modules and restocks.",
      "final.microcopy": "For hairstylists, barbers &amp; beauty professionals.",

      /* footer */
      "footer.waitlist": "Waitlist",
      "footer.privacy": "Privacy",
      "footer.terms": "Terms",
      "footer.note": "© 2026 Salon by Ordo · A modular, precision-made station system for beauty professionals · salonbyordo.com",

      /* cookie banner */
      "cookie.text": "We use only essential cookies to make this site work. With your consent we also use analytics and marketing cookies to improve Salon by Ordo and measure our ads. Read our <a href=\"/pages/privacy-policy\">privacy policy</a>.",
      "cookie.acceptAll": "Accept all",
      "cookie.essentialOnly": "Essential only",

      /* privacy & terms shared */
      "legal.back": "← Back to site",
      "legal.updated": "Last updated: 25 July 2026",

      /* privacy page */
      "privacy.title": "Privacy Policy",
      "privacy.lead": "This privacy policy explains how Komtinordo bv (\"we\", \"Salon by Ordo\") processes your personal data when you sign up for the waitlist via salonbyordo.com. We process your data in accordance with the General Data Protection Regulation (GDPR).",
      "privacy.h2.1": "Data Controller",
      "privacy.body.1": "Komtinordo bv<br>Invalidenstraat 52, 9041 Oostakker, Belgium<br>Company/VAT number: BE 1032.140.178<br>Contact: <a href=\"mailto:info@ordobox.be\">info@ordobox.be</a>",
      "privacy.h2.2": "What Data We Collect",
      "privacy.body.2.1": "Your email address, which you provide yourself via the waitlist form.",
      "privacy.body.2.2": "Technical data (IP address, browser type) only if you consent to analytics and marketing cookies.",
      "privacy.h2.3": "How We Use Your Data",
      "privacy.body.3.1": "To keep you informed about the launch of Salon by Ordo and the early-access conditions.",
      "privacy.body.3.2": "To inform you about founder pricing and product updates.",
      "privacy.body.3.3": "With your consent: to measure website visits and the effectiveness of our advertising.",
      "privacy.h2.4": "Legal Basis",
      "privacy.body.4": "We process your email address on the basis of your <strong>consent</strong> (Art. 6.1.a GDPR), which you give when signing up. For cookies, your explicit consent via the cookie banner applies. You may withdraw your consent at any time.",
      "privacy.h2.5": "Retention Period",
      "privacy.body.5": "We keep your email address until you unsubscribe or for a maximum of 24 months after launch, unless you become a customer. After that, we delete your data.",
      "privacy.h2.6": "Recipients and Processors",
      "privacy.body.6": "Your data is processed within our webshop environment (Shopify) and email infrastructure. These parties act as processors and process your data solely on our instructions. We never sell your data to third parties.",
      "privacy.h2.7": "Your Rights",
      "privacy.body.7.1": "Right of access, correction and erasure of your data.",
      "privacy.body.7.2": "Right to restriction of and objection to processing.",
      "privacy.body.7.3": "Right to data portability.",
      "privacy.body.7.4": "Right to withdraw your consent.",
      "privacy.body.7.5": "Send your request to <a href=\"mailto:info@ordobox.be\">info@ordobox.be</a>. You also have the right to lodge a complaint with the Data Protection Authority (<a href=\"https://www.gegevensbeschermingsautoriteit.be\" target=\"_blank\" rel=\"noopener\">gegevensbeschermingsautoriteit.be</a>).",
      "privacy.h2.8": "Changes",
      "privacy.body.8": "We may amend this policy. The most recent version is always available on this page.",

      /* terms page */
      "terms.title": "Terms &amp; Conditions",
      "terms.lead": "These terms apply to the use of the website salonbyordo.com and to signing up for the Salon by Ordo waitlist, a brand of Komtinordo bv.",
      "terms.h2.1": "The Waitlist",
      "terms.body.1.1": "Signing up for the waitlist is free and non-binding.",
      "terms.body.1.2": "Signing up does not constitute a purchase, reservation or guaranteed delivery.",
      "terms.body.1.3": "Early access and founder pricing are conditional offers that may change until the moment of actual sale.",
      "terms.h2.2": "Intellectual Property",
      "terms.body.2": "All content on this site — texts, images, logos, the modular design and the Salon by Ordo brand name — is protected and remains the property of Komtinordo bv. Nothing may be copied without prior written consent.",
      "terms.h2.3": "Liability",
      "terms.body.3": "We strive for accurate and up-to-date information, but cannot guarantee that the site is free of errors or always available. We are not liable for indirect damages arising from use of the site.",
      "terms.h2.4": "Governing Law",
      "terms.body.4": "These terms are governed by Belgian law. Disputes fall under the jurisdiction of the courts of the district of our registered office.",
      "terms.h2.5": "Contact",
      "terms.body.5": "Questions about these terms? Email us at <a href=\"mailto:info@ordobox.be\">info@ordobox.be</a>.",

      /* legal footer links */
      "legal.foot.home": "Home",
      "legal.foot.privacy": "Privacy Policy",
      "legal.foot.terms": "Terms &amp; Conditions",
      "legal.foot.contact": "Contact",
      "legal.foot.note": "© 2026 Salon by Ordo — a brand of Komtinordo bv · salonbyordo.com"
    },

    nl: {
      /* nav */
      "nav.system": "Het Systeem",
      "nav.workflow": "Workflow",
      "nav.who": "Voor Wie",
      "nav.origin": "Ons Verhaal",
      "nav.cta": "Shop",
      "nav.shopall": "Alle Onderdelen",

      /* shop all */
      "shopall.eyebrow": "Elk onderdeel, apart",
      "shopall.h2": "Alle onderdelen.",
      "shopall.p": "Boxen, bescherming, modules, inserts en add-ons, elk apart verkrijgbaar. Bouw je opstelling uit, vervang een onderdeel, of stel iets nieuws samen, stuk per stuk.",
      "shopall.base.h3": "ORDO Basis",
      "shopall.base.p": "De lege basis waarmee elk station begint. Small, Medium of Large, telkens dezelfde grid.",
      "shopall.protect.h3": "Bescherming",
      "shopall.protect.p": "Binnenbescherming en anti-slip pads, houden elke basis stabiel en elk werkvlak beschermd.",
      "shopall.modules.h3": "Frame Modules",
      "shopall.modules.p": "De bouwblokjes van elk station, van één enkel vak tot een volledige rij.",
      "shopall.elevation.h3": "Elevatiemodules",
      "shopall.elevation.p": "Massieve blokjes die een module hoger zetten in je basis, zodat kortere tools en producten zichtbaar en binnen handbereik blijven.",
      "shopall.inserts.h3": "Functionele modules",
      "shopall.inserts.p": "Pasklare organisers voor scharen, kammen, tondeuses en trimmers, afgestemd op je cubes.",
      "shopall.addons.h3": "Add-Ons",
      "shopall.addons.p": "Klikken vast aan de buitenwand voor tondeusekapjes, stylingtools en houders, zonder ruimte te kosten binnenin.",
      "shopall.contact.eyebrow": "Op zoek naar iets specifiek",
      "shopall.contact.h2": "Vind je het onderdeel niet dat je zoekt?",
      "shopall.contact.p": "Mail ons de SKU, maat of een foto van je opstelling en we helpen je het juiste stuk vinden.",
      "shopall.contact.cta": "Mail info@ordobox.be",

      /* hero */
      "hero.eyebrow": "Voor kappers, barbiers &amp; beauty professionals",
      "hero.h1": "Jouw tools.<br>Jouw flow.<br>Gebouwd om mooi te werken.",
      "hero.sub": "Een modulair systeem, gebouwd rond de manier waarop jij werkt. Drie maten, oneindig te configureren.",
      "hero.qualifier": "Drie maten. Één modulair systeem.",
      "hero.cta": "Shop de collectie",
      "hero.waitlist_link": "Op zoek naar een custom build of nieuwe kleur? Sluit je aan bij de meldlijst",
      "hero.microcopy": "Sluit je aan bij de eerste professionals die Salon by Ordo vormgeven.",
      "shop.custom.eyebrow": "Stel zelf samen",
      "shop.custom.h3": "Custom configuratie",
      "shop.custom.p": "Start van een lege basis en voeg precies de modules toe die jij nodig hebt, stuk voor stuk.",
      "shop.custom.cta": "Open de configurator",

      "form.email.placeholder": "Je werk-e-mailadres",
      "form.submit": "Vroege Toegang",
      "form.consent": "Ik ga akkoord met het <a href=\"/pages/privacy-policy\">privacybeleid</a> en geef toestemming om gecontacteerd te worden over Salon by Ordo.",
      "form.thanks.h3": "Je staat op de lijst.",
      "form.thanks.p1": "We houden je op de hoogte zodra de eerste modules vorm krijgen — met founder-prijzen en inspraak in wat we bouwen.",
      "form.thanks.p2": "We houden je op de hoogte zodra de eerste modules vorm krijgen.",

      "shop.eyebrow": "Nu beschikbaar",
      "shop.h2": "Kies je station.",
      "shop.p": "Drie maten, één systeem. Start waar jouw kit vandaag staat — elke maat configureert op dezelfde manier.",
      "shop.cta": "Shop nu",

      "system.eyebrow": "Een station, geen opbergdoos",
      "system.h2": "Een modulair professioneel station.<br>Geen zoveelste plastic organizer.",
      "system.p": "Eén doordachte basis. Een groeiende reeks modules. Configureer een opstelling rond de tools en producten die je écht gebruikt — en herschik ze zodra je service verandert. Precisiegemaakt, laag per laag, om even goed in je handen te liggen als op je station.",

      "transform.eyebrow": "Het verschil op jouw station",
      "transform.h2": "Van alles, overal<br>naar alles op zijn plaats.",
      "transform.p": "Elke professional kent de lade, de trolley, de tas waarin tools verstrikt raken en tijd verdwijnt. Salon by Ordo verandert die chaos in een systeem gebouwd rond jouw handen.",
      "ba.before.tag": "Voordien",
      "ba.before.caption": "Verstrikte tools. Verloren minuten. Een station dat tegen je werkt.",
      "ba.after.tag": "Nadien",
      "ba.after.caption": "Eén modulair systeem. Elk essentieel item zichtbaar, gesorteerd en binnen handbereik.",

      "flow.eyebrow": "Configureer · Werk · Reset",
      "flow.h2": "Alles zichtbaar.<br>Binnen handbereik. Op zijn plaats.",
      "flow.cell1.h3": "Configureer je vak",
      "flow.cell1.p": "Bouw een opstelling rond je eigen kit — scharen, tondeuses, borstels, kleur, product — en herconfigureer ze zodra je overschakelt van knippen naar kleur, nagels of wimperwerk.",
      "flow.cell2.h3": "Alles in flow",
      "flow.cell2.p": "Een doordachte plaats voor elk essentieel item houdt je station gefocust en rustig, zodat de volgende stap altijd één vloeiende beweging verder is.",
      "flow.cell3.h3": "Gemaakt om mee te reizen",
      "flow.cell3.p": "Een persoonlijke, georganiseerde kit die met je dag meereist — stoel naar trolley, suite naar set naar huisbezoek — en in seconden weer klaarstaat.",

      "flowimg.eyebrow": "Gebouwd voor de service",
      "flowimg.h2": "Ontworpen voor het tempo<br>waarop jij écht werkt.",
      "flowimg.p": "Beauty work is snel, tactiel en onvergevingsgezind voor rommel. Salon by Ordo is vormgegeven rond echte servicemomenten — de reikbeweging tijdens het föhnen, de reset tussen klanten, de opstelling op een nieuwe locatie — zodat jouw station je vak bijhoudt in plaats van vertraagt.",

      "who.eyebrow": "Eén systeem, vele vakgebieden",
      "who.h2": "Gemaakt voor de professionals<br>achter de stoel.",
      "persona.barber.h3": "De Barbier",
      "persona.barber.p": "Messen, tondeuses en kammen, geordend voor elke fade — een station dat het tempo van elke klant in de stoel volgt.",
      "persona.colourist.h3": "De Colorist",
      "persona.colourist.p": "Kommen, kwasten, folies en formules — elk op zijn plek, zodat precisiewerk in kleur nooit op het zoeken wacht.",
      "persona.stylist.h3": "De Stylist",
      "persona.stylist.p": "Scharen, clips en finishingtools, klaargelegd voor flow van eerste knip tot laatste blik in de spiegel.",
      "persona.nail.h3": "De Nagelstyliste",
      "persona.nail.p": "Lakken, vijlen en fijne penselen binnen handbereik, voor detailwerk dat kalm en zuiver blijft.",
      "persona.makeup.h3": "De Make-upartiest",
      "persona.makeup.p": "Kwasten, paletten en producten, geordend voor de look — elke tool klaar voor het licht valt.",

      "origin.eyebrow": "De oorsprong van Ordo",
      "origin.h2": "Ontstaan uit een systeem<br>gebouwd voor professionele keukens.",
      "origin.p": "Ordo begon op de pass — een modulaire toolbox gemaakt door chefs, voor chefs, waar mise-en-place en flow de avond bepalen. Salon by Ordo draagt diezelfde discipline achter de stoel: alles doordacht, alles op zijn plaats, zodat professionals zich kunnen focussen op het werk waar ze om gekend zijn.",

      /* faq */
      "faq.eyebrow": "Goed om te weten",
      "faq.h2": "Vragen, beantwoord.",
      "faq.q1": "Wat is Salon by Ordo precies?",
      "faq.a1": "Een modulair organisatiesysteem voor kappers, barbiers en beauty professionals. E\u00e9n basis en een groeiende set modules die je configureert rond de tools die je echt gebruikt, en die je hervormt wanneer je dienstverlening verandert.",
      "faq.q2": "Welke maten zijn er en wat kosten ze?",
      "faq.a2": "Elke kant-en-klare set is er in Standard of With Add-ons. Small: &euro;89,99 / &euro;99,99. Medium: &euro;109,99 / &euro;129,99. Large (enkel Hairdresser): &euro;139,99 / &euro;159,99. Alle maten zijn gebouwd op hetzelfde modulaire systeem, dus modules passen over de maten heen.",
      "faq.q3": "Kan ik mijn eigen configuratie samenstellen?",
      "faq.a3": "Ja. Start van een lege basis in de configurator en voeg precies de modules toe die je nodig hebt, stuk voor stuk. Je vindt de configurator op configure.salonbyordo.com.",
      "faq.q4": "Voor wie is het gemaakt?",
      "faq.a4": "Professionals achter de stoel: kappers, barbiers, coloristen, make-upartiesten en nagelstylisten.",
      "faq.q5": "Hoe verhoudt Salon by Ordo zich tot Ordo?",
      "faq.a5": "Ordo begon als een modulaire toolbox gemaakt door chefs, voor chefs, waar mise-en-place en flow de avond bepalen. Salon by Ordo draagt diezelfde discipline achter de stoel.",
      "faq.q6": "Hoe verlopen verzending en retour?",
      "faq.a6": "Alle details staan in ons Verzendbeleid en ons Retour- en Terugbetalingsbeleid, beide gelinkt in de footer van elke pagina.",

      "final.eyebrow": "Blijf op de hoogte",
      "final.h2": "Nieuwe kleuren. Nieuwe modules.",
      "final.sub": "Nu al leverbaar in drie maten. Sluit je aan bij de meldlijst voor nieuwe kleuren, modules en herbevoorrading.",
      "final.microcopy": "Voor kappers, barbiers &amp; beauty professionals.",

      "footer.waitlist": "Wachtlijst",
      "footer.privacy": "Privacy",
      "footer.terms": "Voorwaarden",
      "footer.note": "© 2026 Salon by Ordo · Een modulair, precisievervaardigd stationssysteem voor beauty professionals · salonbyordo.com",

      "cookie.text": "We gebruiken enkel essentiële cookies om deze site te laten werken. Met jouw toestemming gebruiken we ook analytische en marketingcookies om Salon by Ordo te verbeteren en onze advertenties te meten. Lees ons <a href=\"/pages/privacy-policy\">privacybeleid</a>.",
      "cookie.acceptAll": "Alles accepteren",
      "cookie.essentialOnly": "Enkel essentiële",

      "legal.back": "← Terug naar site",
      "legal.updated": "Laatst bijgewerkt: 25 juli 2026",

      "privacy.title": "Privacybeleid",
      "privacy.lead": "Dit privacybeleid legt uit hoe Komtinordo bv (\"wij\", \"Salon by Ordo\") jouw persoonsgegevens verwerkt wanneer je je inschrijft op de wachtlijst via salonbyordo.com. Wij verwerken je gegevens conform de Algemene Verordening Gegevensbescherming (AVG/GDPR).",
      "privacy.h2.1": "Verwerkingsverantwoordelijke",
      "privacy.body.1": "Komtinordo bv<br>Invalidenstraat 52, 9041 Oostakker, België<br>Ondernemings-/BTW-nummer: BE 1032.140.178<br>Contact: <a href=\"mailto:info@ordobox.be\">info@ordobox.be</a>",
      "privacy.h2.2": "Welke gegevens verzamelen wij",
      "privacy.body.2.1": "Je e-mailadres, dat je zelf opgeeft via het wachtlijstformulier.",
      "privacy.body.2.2": "Technische gegevens (IP-adres, browsertype) enkel indien je toestemming geeft voor analyse- en marketingcookies.",
      "privacy.h2.3": "Waarvoor gebruiken wij je gegevens",
      "privacy.body.3.1": "Je op de hoogte houden van de lancering van Salon by Ordo en de early-access voorwaarden.",
      "privacy.body.3.2": "Je informeren over founder-pricing en productupdates.",
      "privacy.body.3.3": "Met jouw toestemming: het meten van websitebezoek en de effectiviteit van advertenties.",
      "privacy.h2.4": "Rechtsgrond",
      "privacy.body.4": "Wij verwerken je e-mailadres op basis van jouw <strong>toestemming</strong> (art. 6.1.a AVG), die je bij het inschrijven geeft. Voor cookies geldt jouw expliciete toestemming via de cookiebanner. Je kan je toestemming op elk moment intrekken.",
      "privacy.h2.5": "Bewaartermijn",
      "privacy.body.5": "Wij bewaren je e-mailadres tot je je uitschrijft of tot maximaal 24 maanden na de lancering, tenzij je klant wordt. Daarna verwijderen wij je gegevens.",
      "privacy.h2.6": "Ontvangers en verwerkers",
      "privacy.body.6": "Je gegevens worden verwerkt binnen onze webshopomgeving (Shopify) en e-mailinfrastructuur. Deze partijen treden op als verwerker en verwerken je gegevens uitsluitend in onze opdracht. Wij verkopen je gegevens nooit aan derden.",
      "privacy.h2.7": "Jouw rechten",
      "privacy.body.7.1": "Recht op inzage, correctie en verwijdering van je gegevens.",
      "privacy.body.7.2": "Recht op beperking en bezwaar tegen verwerking.",
      "privacy.body.7.3": "Recht op overdraagbaarheid van je gegevens.",
      "privacy.body.7.4": "Recht om je toestemming in te trekken.",
      "privacy.body.7.5": "Stuur je verzoek naar <a href=\"mailto:info@ordobox.be\">info@ordobox.be</a>. Je hebt ook het recht een klacht in te dienen bij de Gegevensbeschermingsautoriteit (<a href=\"https://www.gegevensbeschermingsautoriteit.be\" target=\"_blank\" rel=\"noopener\">gegevensbeschermingsautoriteit.be</a>).",
      "privacy.h2.8": "Wijzigingen",
      "privacy.body.8": "Wij kunnen dit beleid aanpassen. De meest recente versie staat steeds op deze pagina.",

      "terms.title": "Algemene Voorwaarden",
      "terms.lead": "Deze voorwaarden zijn van toepassing op het gebruik van de website salonbyordo.com en op inschrijving op de wachtlijst van Salon by Ordo, een merk van Komtinordo bv.",
      "terms.h2.1": "De wachtlijst",
      "terms.body.1.1": "Inschrijving op de wachtlijst is gratis en vrijblijvend.",
      "terms.body.1.2": "Inschrijving houdt geen aankoop, reservatie of gegarandeerde levering in.",
      "terms.body.1.3": "Early-access en founder-pricing zijn voorwaardelijke aanbiedingen die kunnen wijzigen tot het moment van effectieve verkoop.",
      "terms.h2.2": "Intellectuele eigendom",
      "terms.body.2": "Alle inhoud op deze site — teksten, beelden, logo's, het modulaire ontwerp en de merknaam Salon by Ordo — is beschermd en blijft eigendom van Komtinordo bv. Niets mag worden overgenomen zonder voorafgaande schriftelijke toestemming.",
      "terms.h2.3": "Aansprakelijkheid",
      "terms.body.3": "Wij streven naar correcte en actuele informatie, maar kunnen niet garanderen dat de site vrij is van fouten of steeds beschikbaar is. Wij zijn niet aansprakelijk voor onrechtstreekse schade voortvloeiend uit het gebruik van de site.",
      "terms.h2.4": "Toepasselijk recht",
      "terms.body.4": "Op deze voorwaarden is het Belgisch recht van toepassing. Geschillen behoren tot de bevoegdheid van de rechtbanken van het arrondissement van onze maatschappelijke zetel.",
      "terms.h2.5": "Contact",
      "terms.body.5": "Vragen over deze voorwaarden? Mail ons op <a href=\"mailto:info@ordobox.be\">info@ordobox.be</a>.",

      "legal.foot.home": "Home",
      "legal.foot.privacy": "Privacybeleid",
      "legal.foot.terms": "Algemene voorwaarden",
      "legal.foot.contact": "Contact",
      "legal.foot.note": "© 2026 Salon by Ordo — een merk van Komtinordo bv · salonbyordo.com"
    }
  };

  /* ---------------------------------------------------------------------
   * i18n ENGINE
   * ------------------------------------------------------------------- */
  function detectLang(){
    try {
      var saved = localStorage.getItem('sbo_lang');
      if (saved === 'en' || saved === 'nl') return saved;
    } catch(e){}
    var nav = ((navigator.language || navigator.userLanguage || 'en') + '').toLowerCase();
    return nav.indexOf('nl') === 0 ? 'nl' : 'en';
  }

  function applyLang(lang){
    if (lang !== 'en' && lang !== 'nl') lang = 'en';
    var dict = translations[lang] || translations.en;

    document.documentElement.setAttribute('lang', lang);

    document.querySelectorAll('[data-i18n]').forEach(function(el){
      var key = el.getAttribute('data-i18n');
      if (dict[key] !== undefined) el.innerHTML = dict[key];
    });

    document.querySelectorAll('[data-i18n-placeholder]').forEach(function(el){
      var key = el.getAttribute('data-i18n-placeholder');
      if (dict[key] !== undefined) el.setAttribute('placeholder', dict[key]);
    });

    document.querySelectorAll('[data-lang-switch]').forEach(function(el){
      el.classList.toggle('active-lang', el.getAttribute('data-lang-switch') === lang);
    });

    try { localStorage.setItem('sbo_lang', lang); } catch(e){}
  }

  function initI18n(){
    applyLang(detectLang());
    document.querySelectorAll('[data-lang-switch]').forEach(function(el){
      el.addEventListener('click', function(ev){
        ev.preventDefault();
        applyLang(el.getAttribute('data-lang-switch'));
      });
    });
  }

  /* ---------------------------------------------------------------------
   * NAV SCROLL EFFECT (index page)
   * ------------------------------------------------------------------- */
  function initNavScroll(){
    var nav = document.getElementById('nav');
    if (!nav) return;
    addEventListener('scroll', function(){
      nav.classList.toggle('scrolled', scrollY > 60);
    });
  }

  /* ---------------------------------------------------------------------
   * REVEAL ON SCROLL
   * ------------------------------------------------------------------- */
  function initReveal(){
    var items = document.querySelectorAll('.reveal');
    if (!items.length) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px 150px 0px' });
    items.forEach(function(el){ io.observe(el); });
  }

  /* ---------------------------------------------------------------------
   * WAITLIST FORM — sends email to Salon by Ordo waitlist webhook
   * ------------------------------------------------------------------- */
  var WAITLIST_WEBHOOK_URL = 'https://webhooks.tasklet.ai/v1/public/webhook/a_pm8c3je34w1hm1wgkjpt?token=cbba1ce94f4749b6ffa1e3e9fff0486c';

  function initWaitforms(){
    document.querySelectorAll('[data-form]').forEach(function(f){
      f.addEventListener('submit', function(ev){
        ev.preventDefault();
        var emailInput = f.querySelector('input[type="email"]');
        var email = emailInput ? emailInput.value : '';
        var t = f.parentElement.querySelector('[data-thanks]');

        fetch(WAITLIST_WEBHOOK_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: email,
            source: 'salonbyordo.com',
            page: window.location.pathname,
            submittedAt: new Date().toISOString()
          })
        }).catch(function(err){
          // Network/webhook error: still show confirmation so the visitor
          // isn't stuck, but log for later follow-up.
          console.error('Salon by Ordo waitlist submit failed', err);
        });

        f.style.display = 'none';
        if (t) t.classList.add('show');
      });
    });
  }

  /* ---------------------------------------------------------------------
   * COOKIE CONSENT BANNER
   * ------------------------------------------------------------------- */
  function initCookieBanner(){
    var KEY = 'sbo_consent';
    var box = document.getElementById('cookie');
    if (!box) return;
    var stored;
    try { stored = localStorage.getItem(KEY); } catch(e){}
    if (!stored) box.classList.add('show');
    box.querySelectorAll('[data-cookie]').forEach(function(b){
      b.addEventListener('click', function(){
        try { localStorage.setItem(KEY, b.getAttribute('data-cookie')); } catch(e){}
        box.classList.remove('show');
        // Marketing/analytics scripts (e.g. Meta pixel) load here only when value === 'all'
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function(){
    initI18n();
    initNavScroll();
    initReveal();
    initWaitforms();
    initCookieBanner();
  });

})();


/* GA4 Measurement Protocol - add_to_cart fix for non-AJAX cart forms (added aug 2026) */
(function () {
  var MEASUREMENT_ID = "G-06JNHBPGSD";
  var API_SECRET = "NE6D7xY8T6yZTxzzOra5wA";
  var GA_ENDPOINT = "https://www.google-analytics.com/mp/collect?measurement_id=" + MEASUREMENT_ID + "&api_secret=" + API_SECRET;

  function getClientId() {
    var match = document.cookie.match(/_ga=(GA\d\.\d\.\d+\.\d+)/);
    if (match) {
      var parts = match[1].split(".");
      if (parts.length >= 4) return parts[2] + "." + parts[3];
    }
    var stored = null;
    try { stored = localStorage.getItem("ga4_pixel_client_id"); } catch (e) {}
    if (stored) return stored;
    var generated = String(Math.floor(Math.random() * 2147483647)) + "." + String(Math.floor(Date.now() / 1000));
    try { localStorage.setItem("ga4_pixel_client_id", generated); } catch (e) {}
    return generated;
  }

  function sendAddToCart(variantId, quantity) {
    try {
      var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      var product = meta && meta.product;
      if (!product || !product.variants) return;
      var variant = null;
      for (var i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].id) === String(variantId)) { variant = product.variants[i]; break; }
      }
      if (!variant) return;
      var price = (variant.price || 0) / 100;
      var currency = meta.currency || "EUR";
      var body = {
        client_id: getClientId(),
        events: [{
          name: "add_to_cart",
          params: {
            currency: currency,
            value: price * quantity,
            items: [{
              item_id: String(variant.id),
              item_name: variant.name || product.title || "unknown",
              price: price,
              quantity: quantity
            }]
          }
        }]
      };
      var blob = new Blob([JSON.stringify(body)], { type: "text/plain" });
      navigator.sendBeacon(GA_ENDPOINT, blob);
    } catch (e) {}
  }

  document.addEventListener("submit", function (evt) {
    var form = evt.target;
    if (!form || !form.action || form.action.indexOf("/cart/add") === -1) return;
    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    var variantId = idInput ? idInput.value : null;
    var quantity = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
    if (variantId) sendAddToCart(variantId, quantity);
  }, true);
})();
